export const CHANGE_SCREEN = 'CHANGE_SCREEN'
export const GET_PERFIL_INFO = 'GET_PERFIL_INFO'
export const FILTER_FLASHCARD = 'FILTER_FLASHCARD'
export const COMMENT_OUTPUTS = 'COMMENT_OUTPUTS'
export const EDIT_PERFIL = 'EDIT_PERFIL'
export const CREATE_PERFIL = 'CREATE_PERFIL'
export const EDIT_AVATAR = 'EDIT_AVATAR'
export const CHANGE_PASS = 'CHANGE_PASS'
